"use client";

import React from "react";
import Modal from "./ui/Modal";
import { useLanguage } from "../contexts/LanguageContext";

const DEMO_VIDEO = "xpwdBtlWUwQ";

const VideoModal = ({ isOpen, onClose, videoId = DEMO_VIDEO, title }) => {
  const { t } = useLanguage();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="xl"
      title={title || t.management.watchDemo}
      closeLabel={t.ui.close}
    >
      <div className="relative aspect-video w-full overflow-hidden rounded-md border border-line bg-black">
        {isOpen ? (
          <iframe
            className="absolute inset-0 h-full w-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
            title={title || t.management.watchDemo}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : null}
      </div>
    </Modal>
  );
};

export default VideoModal;
